export {default} from './loader'